import contract from "../../../services/contracts";
import sales from "../../../services/sales";
import constantes from "../../common/constantes";
import messageDialog from "../../../components/message-dialog.vue";
import ModalRecharge from "./modal-change-automatic-value.vue";
import ModalAutomatic from "./modal-automatic-value.vue";
import {
  cents
} from "../../../filters/number";
import {
  isNull
} from "util";
// import Payment from '../../common/payment/payment.vue'
import param from "../../../services/param";
import Invoice from '../../../services/invoice';
import Vehicles from '../../../services/vehicles'

export default {
  data() {
    return {
      loading: undefined,
      loadingRecharge: undefined,
      contract: undefined,
      invoice: undefined,
      recharge: undefined,
      rechargeAlter: undefined,
      showModal: undefined,
      valueTaxRechargeAlter: undefined,
      rechargeQtd: undefined,
      modalRecharge: {},
      newLimit: undefined,
      fmtValorLimiteCredito: undefined,
      checkVehicle: true,
      groupers: [],
      isModalVisible: false,
      selectedGrouper: null,
      isAddModalVisible: false,
      newGrouperName: '',
      newGrouperDescription: '',
      isEditModalVisible: false,
      editGrouperName: '',
      editGrouperDescription: '',
      isGrouper: null
    };
  },

  watch: {

    newLimit(newVal) {
      this.contract.limitCredit = newVal;
    }

  },
  created() {
    const isGrouper = JSON.parse(localStorage.getItem('grouper'));
    this.isGrouper = isGrouper;
  },

  mounted: function () {
    this.loadContract();
    this.loadGroupers();
  },
  methods: {

    setLimitValue: function (newValue) {
      this.contract.limitCredit = newValue;
      this.newLimit = newValue;
    },

    isPessoaJuridica() {
      return (JSON.parse(localStorage.getItem("currentUser")).type == "PESSOA_JURIDICA");
    },
    hideModal() {
      this.showModal = false;
      this.rechargeAlter = this.recharge;
    },
    alterRechargeUnit() {
      this.showModal = false;
      this.contract.rechargeValue = this.rechargeAlter.quantity;
      this.loading = contract
        .updateContract({
          contract: this.contract
        })
        .then(response => {
          if (response.data.status.code == 0) {
            this.recharge = this.rechargeAlter;
          }
        });
    },
    calculate(qtd) {
      this.loadingRecharge = sales
        .calculateRechargeRate({
          quantity: qtd,
          planId: this.contract.plan.planId
        })
        .then(result => {
          this.rechargeAlter = result;
        });
    },
    calculateRecharge() {
      if (this.planId == 31 || this.planId == 32) {
        return;
      }

      this.loading = sales
        .calculateRechargeRate({
          quantity: this.contract.rechargeValue,
          planId: this.contract.plan.planId
        })
        .then(result => {
          this.recharge = result;
          this.rechargeAlter = this.recharge;
        });
    },
    getImage(payment) {
      return (
        "/static/payment-methods/" + payment.imagePath.split(".")[0] + ".svg"
      );
    },
    vencimentos() {
      let b = this.contract.billingDay;
      if (this.contract.billingDay2) b += " - " + this.contract.billingDay2;
      if (this.contract.billingDay3) b += " - " + this.contract.billingDay3;

      return b;
    },
    loadContract() {
      this.loading = contract.getContractByContractId(this.contractId)
        .then(contract => {
          this.contract = contract;
          this.rechargeQtd = this.contract.rechargeValue;

          // let embarcador = _.find(contract, o => {
          //   // return this.getKindPlan(o.plan.planId)  == 'EMBARCADOR';
          //   return o.plan.planId == 6 || o.plan.planId == 8;
          // });

          // if(!embarcador){
          if (this.contract.plan.planId != 6 && this.contract.plan.planId != 8) {

            // se o cliente tiver algum plano embarcador nao faz a validacao
            Vehicles.checkVehicleByMoveMaisId(JSON.parse(localStorage.getItem("currentUser")).moveMaisId).then(res => {
              this.checkVehicle = res.checkVehicle;


            });
          }

          if (this.contract.plan.planId == constantes.PLAN_POS) {
            Invoice.list(this.contractId).then(resp => {
              if (resp && resp.length > 0) this.invoice = resp[0];
              //this.$forceUpdate();
            });
          }

          if (this.planHasAutRecharge(this.contract.plan.planId)) {
            this.calculateRecharge();
          }
        })
        .catch(erro => {
          messageDialog.show({
            title: "Erro",
            message: erro.data.status.message,
            type: "OK"
          });
        });
    },
    showMessageContract() {
      messageDialog.show({
        title: "Info",
        headerClass: "modal-info",
        message: "Recarga e inclusão de novo veículo somente estarão disponíveis após a ativação do contrato"
      });
    },

    openModalRecharge(contractId) {
      this.$set(this.modalRecharge, contractId, true);
    },

    closeModalRecharge(contractId, newRecharge) {
      this.$set(this.modalRecharge, contractId, false);
      if (newRecharge) {
        this.contract.rechargeValue = newRecharge;
        this.calculateRecharge();
      }
    },

    setLimitValue: function (newValue) {
      this.contract.limitCredit = newValue.replace(/[^0-9]/g, '');
    },

    //CAP-36
    getUpdateAlert() {
      let Flag = this.contract.lcFlag ? 1 : 0;
      if (this.planId != 8 && this.planId != 28) {
        if (this.contract.limitCredit < 1000) {
          messageDialog.show({
            title: "Erro",
            message: "Não é possivel inserir um valor abaixo de R$ 10 reais. Tente novamente",
            type: "OK"
          });
        } else if (this.contract.limitCredit == 0) {
          messageDialog.show({
            title: "Erro",
            message: "Valor não permitido!",
            type: "OK"
          });
        } else {
          this.loading = contract.getUpdateValueAlert(Flag, this.contract.limitCredit, this.contract.contractId)
            .then(values => {
              messageDialog.show({
                title: "Sucesso",
                message: "Alteração realizada com sucesso!",
                type: "OK"
              });
            })
            .catch(erro => {
              messageDialog.show({
                title: "Erro",
                message: erro.data.status.message,
                type: "OK"
              });
            });
        }
      } else {
        let conversion = parseInt(this.contract.limitCredit);
        //
        if ((conversion < 1) || (conversion > 80)) {
          messageDialog.show({
            title: "Error",
            message: "O percentual deve ser entre 1% a 80%",
            type: "OK"
          });
        } else if ((conversion == 0) || (conversion == undefined) || (conversion == null) || (!conversion)) {
          messageDialog.show({
            title: "Error",
            message: "Valor não permitido!",
            type: "OK"
          });
        } else {
          this.loading = contract.getUpdateValueAlert(Flag, this.contract.limitCredit, this.contract.contractId)
            .then(values => {
              messageDialog.show({
                title: "Sucesso",
                message: "Alteração realizada com sucesso!",
                type: "OK"
              });
            })
            .catch(erro => {
              messageDialog.show({
                title: "Erro",
                message: erro.data.status.message,
                type: "OK"
              });
            });
        }
      }
    },

    // CAP-36 - Os valores de aviso limite de credito para os planos 21 e 31 ficam na tabela GENERAL_PARAMETERS
    valueFormatted() {
      let chave;

      if (this.contract.plan.planId == 21) {
        chave = "LIMITE_CREDITO_PF";
      } else {
        if (this.contract.plan.planId == 31) {
          chave = "LIMITE_CREDITO_PJ";
        }
      }

      //recupera o valor base
      param.getGeneralParameter({
        key: chave
      }).then((res) => {
        this.contract.limitCredit = res.value.replace(/[^0-9]/g, '');
      });

      this.$nextTick(() => {
        //para o cursor continuar no final do input
        $('#limitValue').val($('#limitValue').val());
      });
      return cents(this.contract.limitCredit);
    },
    loadGroupers() {
      if (this.isGrouper === true) {
        contract.getGroupers(JSON.parse(localStorage.getItem("currentUser")).moveMaisId)
          .then(res => {
            if (res.status.code === 0) {
              this.groupers = res.Agrupadores;
            }
          })
          .catch(err => {
            console.error("Erro ao carregar os agrupadores", err);
          });
      }
    },
    // disableGrouper(nome, idAgrupadorCliente) {
    //   this.selectedGrouper = nome;
    //   this.selectedGrouperId = idAgrupadorCliente;
    //   this.isModalVisible = true;
    // },

    // closeModal() {
    //   this.isModalVisible = false;
    //   this.selectedGrouper = null;
    //   this.selectedGrouperId = null;
    // },
    // confirmDisableGrouper() {
    //   console.log(this.selectedGrouperId)
    //   contract.disableGrouper(this.selectedGrouperId)
    //     .then(response => {
    //         this.groupers = this.groupers.filter(grouper => grouper.idAgrupadorCliente !== this.selectedGrouperId);

    //         console.log(`Agrupador ${this.selectedGrouper} desabilitado e removido com sucesso.`);
    //         this.closeModal();
    //     })
    //     .catch(error => {
    //       console.error("Erro ao desabilitar o agrupador:", error);

    //     });
    // },
    openAddModal() {
      this.isAddModalVisible = true;
    },

    closeAddModal() {
      this.isAddModalVisible = false;
      this.newGrouperName = '';
      this.newGrouperDescription = '';
    },

    addGrouper() {
      if (!this.newGrouperName || !this.newGrouperDescription) {
        messageDialog.show({
          title: "Erro",
          message: "Por favor, preencha todos os campos.",
          type: "OK"
        });
      }

      contract.addGrouper(this.newGrouperName, this.newGrouperDescription, JSON.parse(localStorage.getItem("currentUser")).moveMaisId)
        .then(response => {
          this.closeAddModal();
          this.loadGroupers();

          messageDialog.show({

            title: "Sucesso",
            headerClass: 'modal-success',
            message: response.status.message,
            type: "OK"
          });
        })
        .catch(error => {
          messageDialog.show({
            title: "Erro",
            headerClass: "modal-danger",
            message: error.data.status.message,
            type: "OK"
          });
        });
    },
    openEditModal(name, description, idAgrupadorCliente) {
      this.editGrouperName = name;
      this.editGrouperDescription = description;
      this.selectedGrouper = { idAgrupador: idAgrupadorCliente };
      this.isEditModalVisible = true;
    },
    closeEditModal() {
      this.isEditModalVisible = false;
    },
    submitEdit() {
      contract.editGrouper(this.editGrouperName, this.editGrouperDescription, this.selectedGrouper.idAgrupador)
        .then((data) => {
          messageDialog.show({
            title: "Sucesso",
            headerClass: 'modal-success',
            message: data.status.message,
            type: "OK"
          });
          this.loadGroupers();
        })
        .catch((error) => {
          messageDialog.show({
            title: "Erro",
            headerClass: "modal-danger",
            message: error.data.status.message,
            type: "OK"
          });
        });

      this.closeEditModal();
    },


    mascaraApenasLetrasEAcentos (value) {
      const apenasLetrasEAcentos = value.replace(/[^a-zA-ZÀ-ÿ\s]/g, "")
      const semEspacosDuplos = apenasLetrasEAcentos.replace(/\s+/g, " ")
    
      return semEspacosDuplos
    }
  },

  computed: {
    contractId: function () {
      return this.$route.params.contractId;
    },
    planId() {
      return this.contract.plan.planId;
    },
    getRechargeAut() {
      return this.contract.rechargeValue;
    },
    currentUser() {
      return auth.currentUser;
    },


  },

  
  components: {
    ModalRecharge,
    ModalAutomatic
  }
};



// WEBPACK FOOTER //
// ./src/pages/account/contract/contract-detail.js